import {CompanyModule, ModuleTypes} from '../../types/CompanyProductConfiguration/CompanyModule';

export const isCompanyModuleActive = (moduleType: ModuleTypes, modules: CompanyModule[] = []) => {
  return modules.some((module) => module.identifier === moduleType && module.enabled);
};
